/* K MANNAM v26 — scheduled notices / localized scheduled hero / full header.
 * The server chooses the locale image; this controller filters presentation only.
 * IDs remain original Shopify block IDs. No synthetic filler/blank slides.
 */
(function () {
  'use strict';
  if (window.KMLaunchV26) return;
  var schedule = window.KMScheduleV26;
  if (!schedule) return;
  var controllers = new Map();
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var reasonText = {active:'노출 중', off:'OFF · 고객에게 숨김', scheduled:'시작 대기 · 고객에게 숨김', ended:'종료 · 고객에게 숨김', invalid:'일정 오류 · 날짜/시간 확인'};
  function status(record, now, editor, previewAll) {
    var result = schedule.elementState(record.el, now);
    var isEmpty = record.el.dataset.kmEmpty === 'true';
    var badge = record.el.querySelector('[data-km-schedule-admin]');
    if (badge) {
      badge.hidden = !editor;
      badge.textContent = isEmpty ? '내용/이미지를 입력해 주세요 · 고객에게 숨김' : reasonText[result.reason];
      if (result.error) badge.title = result.error;
    }
    return editor && previewAll ? true : !isEmpty && result.active;
  }
  function setCSS(name, value) {
    var style = document.documentElement.style;
    if (style.getPropertyValue(name) !== value) style.setProperty(name, value);
  }
  function measureHeader() {
    var stack = document.querySelector('[data-km-header-stack]');
    if (!stack) return;
    if (document.body.classList.contains('km-header-full')) setCSS('--header-is-sticky', '1');
    var visibleHeader = Array.from(stack.querySelectorAll('.shopify-section__header')).find(function(el){return el.getBoundingClientRect().height > 0;});
    var announcement = stack.querySelector('[data-km-announcements]');
    setCSS('--header-height', Math.round(visibleHeader ? visibleHeader.getBoundingClientRect().height : 0) + 'px');
    setCSS('--announcement-bar-height', Math.round(announcement ? announcement.getBoundingClientRect().height : 0) + 'px');
    setCSS('--km-full-header-height', Math.round(stack.getBoundingClientRect().height) + 'px');
  }
  function bind(el, type, fn, controller) {
    if (!el) return;
    el.addEventListener(type, fn);
    controller.unbind.push(function(){el.removeEventListener(type, fn);});
  }
  function Notices(root) {
    this.root=root;this.records=Array.from(root.querySelectorAll('[data-km-ann-item]')).map(function(el){return {el:el,id:el.dataset.kmBlockId};});
    this.editor=root.dataset.kmEditor==='true';this.previewAll=root.dataset.kmPreviewAll!=='false';
    this.currentId='';this.visible=[];this.last=Date.now();this.paused=false;this.unbind=[];
    this.delay=Math.max(2000,Number(root.dataset.kmDelay)||4000);
    var self=this;
    bind(root.querySelector('.km-ann-prev'),'click',function(){self.move(-1);},this);
    bind(root.querySelector('.km-ann-next'),'click',function(){self.move(1);},this);
    bind(root,'mouseenter',function(){self.paused=true;},this);
    bind(root,'mouseleave',function(){self.paused=false;self.last=Date.now();},this);
    bind(root,'focusin',function(){self.paused=true;},this);
    bind(root,'focusout',function(e){if(!root.contains(e.relatedTarget)){self.paused=false;self.last=Date.now();}},this);
    this.refresh(Date.now());
  }
  Notices.prototype.refresh=function(now){
    var self=this, old=this.visible.map(function(r){return r.id;}).join('|');
    this.visible=this.records.filter(function(r){return status(r,now,self.editor,self.previewAll);});
    if(!this.visible.some(function(r){return r.id===self.currentId;}))this.currentId=this.visible[0]?this.visible[0].id:'';
    if(old!==this.visible.map(function(r){return r.id;}).join('|')){this.last=now;this.show();}
    if(!this.paused && !document.hidden && !reducedMotion.matches && this.visible.length>1 && now-this.last>=this.delay)this.move(1);
    // Also set the initial no-items state.
    this.root.hidden=this.visible.length===0;
    this.root.querySelectorAll('.km-ann-nav').forEach(function(button){button.hidden=self.visible.length<=1;});
  };
  Notices.prototype.show=function(){
    var self=this;
    this.records.forEach(function(r){r.el.hidden=r.id!==self.currentId;});
    this.root.hidden=this.visible.length===0;measureHeader();
  };
  Notices.prototype.move=function(delta){
    if(!this.visible.length)return;
    var index=this.visible.findIndex(function(r){return r.id===this.currentId;},this);
    this.currentId=this.visible[(index+delta+this.visible.length)%this.visible.length].id;
    this.last=Date.now();this.show();
  };
  Notices.prototype.select=function(id){
    if(this.visible.some(function(r){return r.id===id;})){this.currentId=id;this.paused=true;this.show();}
  };
  Notices.prototype.destroy=function(){this.unbind.forEach(function(fn){fn();});};

  function Hero(root) {
    this.root=root;this.section=root.closest('.shopify-section')||root;
    this.wrapper=root.querySelector('.sm3-swiper>.swiper-wrapper');
    this.swiperEl=root.querySelector('.sm3-swiper');this.grid=root.querySelector('.sm3-grid');
    this.records=Array.from(this.wrapper.children).filter(function(el){return el.classList.contains('sm3-slide');}).map(function(el){return {el:el,id:el.dataset.kmBlockId};});
    this.gridRecords=Array.from(this.grid.children);this.unbind=[];this.visible=[];this.signature=null;this.swiper=null;
    this.editor=root.dataset.kmEditor==='true';this.previewAll=root.dataset.kmPreviewAll!=='false';
    this.paused=reducedMotion.matches;this.bg=root.querySelector('.sm3-modal-bg');this.plus=root.querySelector('.sm3-plus');this.restoreFocus=null;this.savedOverflow='';
    var self=this;
    bind(root.querySelector('.sm3-toggle'),'click',function(){self.paused=!self.paused;self.setPlayback();},this);
    bind(this.plus,'click',function(){self.openModal();},this);
    bind(root.querySelector('.sm3-close'),'click',function(){self.closeModal();},this);
    bind(this.bg,'click',function(e){if(e.target===self.bg)self.closeModal();},this);
    bind(document,'keydown',function(e){
      if(!self.bg.classList.contains('open'))return;
      if(e.key==='Escape'){e.preventDefault();self.closeModal();}
      if(e.key==='Tab'){
        var items=Array.from(self.bg.querySelectorAll('a[href],button:not([disabled]),[tabindex="0"]')).filter(function(el){return el.getClientRects().length;});
        if(!items.length)return;
        var first=items[0],last=items[items.length-1];
        if(e.shiftKey && document.activeElement===first){e.preventDefault();last.focus();}
        else if(!e.shiftKey && document.activeElement===last){e.preventDefault();first.focus();}
      }
    },this);
    this.refresh(Date.now());
  }
  Hero.prototype.refresh=function(now){
    var self=this;
    var visible=this.records.filter(function(r){return status(r,now,self.editor,self.previewAll);});
    var desktop=window.matchMedia('(min-width:750px)').matches;
    var signature=visible.map(function(r){return r.id;}).join('|')+'|'+desktop;
    if(signature===this.signature && (this.swiper || !visible.length))return;
    this.signature=signature;
    var oldId=this.swiper && this.visible[this.swiper.realIndex % this.visible.length] ? this.visible[this.swiper.realIndex % this.visible.length].id : '';
    if(this.swiper && !this.swiper.destroyed)this.swiper.destroy(true,true);
    this.swiper=null;this.root._sm3Swiper=null;this.visible=visible;
    var activeIds=new Set(visible.map(function(r){return r.id;}));
    this.wrapper.replaceChildren.apply(this.wrapper,visible.map(function(r){r.el.hidden=false;return r.el;}));
    this.grid.replaceChildren.apply(this.grid,this.gridRecords.filter(function(el){return activeIds.has(el.dataset.kmBlockId);}));
    this.section.classList.toggle('km-sm3-no-active',visible.length===0);
    this.root.querySelector('.sm3-total').textContent=String(visible.length);
    this.root.querySelector('.sm3-current').textContent=visible.length?'1':'0';
    this.root.querySelector('.sm3-controls').hidden=!visible.length;
    if(!visible.length){this.closeModal(false);return;}
    var perView=desktop?3:1, movable=visible.length>perView;
    this.root.querySelectorAll('.sm3-nav').forEach(function(el){el.hidden=!movable;});
    this.root.querySelector('.sm3-toggle').hidden=!movable;
    // Swiper versions in this theme differ between local and CDN bundles.
    // Older loop engines require >= 2 * slidesPerView. Repeat the sequence only
    // in the internal track for 4/5 desktop banners; retain the actual block count.
    // Never create blank slides or duplicate Shopify editor identifiers.
    if(movable && visible.length < perView*2){
      visible.forEach(function(r){
        var copy=r.el.cloneNode(true);
        copy.removeAttribute('data-km-block-id');
        copy.removeAttribute('data-shopify-editor-block');
        copy.dataset.kmRuntimeClone=r.id;
        copy.setAttribute('aria-hidden','true');
        copy.querySelectorAll('[id]').forEach(function(el){el.removeAttribute('id');});
        copy.querySelectorAll('a,button,[tabindex]').forEach(function(el){el.setAttribute('tabindex','-1');});
        self.wrapper.appendChild(copy);
      });
    }
    if(typeof window.Swiper!=='function')return; // Shared tick retries without hiding valid static images.
    var initial=visible.findIndex(function(r){return r.id===oldId;});
    this.swiper=new window.Swiper(this.swiperEl,{
      slidesPerView:perView,slidesPerGroup:1,spaceBetween:desktop?(Number(this.root.dataset.sm3Gap)||0):0,
      initialSlide:Math.max(0,initial),loop:movable,loopAddBlankSlides:false,
      speed:Number(this.root.dataset.sm3Speed)||500,grabCursor:movable,allowTouchMove:movable,simulateTouch:true,
      watchOverflow:true,centerInsufficientSlides:true,observer:false,
      autoplay:movable?{delay:Number(this.root.dataset.sm3Delay)||4000,disableOnInteraction:false,pauseOnMouseEnter:false}:false,
      navigation:{nextEl:this.root.querySelector('.sm3-next'),prevEl:this.root.querySelector('.sm3-prev')},
      on:{init:function(){self.root.querySelector('.sm3-current').textContent=String((this.realIndex % self.visible.length)+1);},
          slideChange:function(){self.root.querySelector('.sm3-current').textContent=String((this.realIndex % self.visible.length)+1);}}
    });
    this.root._sm3Swiper=this.swiper;this.setPlayback();
    if(this.restoreFocus && !document.activeElement.isConnected)this.root.querySelector('.sm3-close').focus({preventScroll:true});
  };
  Hero.prototype.setPlayback=function(){
    var stop=this.paused||document.hidden||this.bg.classList.contains('open');
    if(this.swiper && this.swiper.autoplay){if(stop)this.swiper.autoplay.stop();else this.swiper.autoplay.start();}
    var toggle=this.root.querySelector('.sm3-toggle');
    toggle.querySelector('.sm3-pause').hidden=this.paused;toggle.querySelector('.sm3-play').hidden=!this.paused;
    toggle.setAttribute('aria-label',this.paused?'슬라이드 재생':'슬라이드 일시정지');
  };
  Hero.prototype.openModal=function(){
    if(this.bg.classList.contains('open'))return;
    this.savedOverflow=document.body.style.overflow;this.restoreFocus=document.activeElement;
    this.bg.classList.add('open');this.bg.setAttribute('aria-hidden','false');this.plus.setAttribute('aria-expanded','true');
    document.body.style.overflow='hidden';this.root.querySelector('.sm3-close').focus({preventScroll:true});this.setPlayback();
  };
  Hero.prototype.closeModal=function(restore){
    if(!this.bg.classList.contains('open'))return;
    this.bg.classList.remove('open');this.bg.setAttribute('aria-hidden','true');this.plus.setAttribute('aria-expanded','false');
    document.body.style.overflow=this.savedOverflow;
    if(restore!==false && this.restoreFocus && this.restoreFocus.isConnected)this.restoreFocus.focus({preventScroll:true});
    this.setPlayback();
  };
  Hero.prototype.select=function(id){
    var index=this.visible.findIndex(function(r){return r.id===id;});
    if(index<0||!this.swiper)return;
    this.paused=true;this.setPlayback();
    if(this.swiper.params.loop)this.swiper.slideToLoop(index,0);else this.swiper.slideTo(index,0);
  };
  Hero.prototype.destroy=function(){
    this.closeModal(false);this.unbind.forEach(function(fn){fn();});
    if(this.swiper && !this.swiper.destroyed)this.swiper.destroy(true,true);
    this.root._sm3Swiper=null;
    this.wrapper.replaceChildren.apply(this.wrapper,this.records.map(function(r){return r.el;}));
    this.grid.replaceChildren.apply(this.grid,this.gridRecords);
  };

  function scan(){
    controllers.forEach(function(controller,el){if(!el.isConnected){controller.destroy();controllers.delete(el);}});
    document.querySelectorAll('[data-km-announcements],[data-km-sm3]').forEach(function(el){
      if(!controllers.has(el))controllers.set(el,el.hasAttribute('data-km-sm3')?new Hero(el):new Notices(el));
    });
    measureHeader();
  }
  function refresh(){
    controllers.forEach(function(controller,el){if(el.isConnected)controller.refresh(Date.now());else{controller.destroy();controllers.delete(el);}});
    measureHeader();
  }
  window.KMLaunchV26={scan:scan,refresh:refresh};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
  document.addEventListener('shopify:section:load',scan);
  document.addEventListener('shopify:section:unload',function(e){
    controllers.forEach(function(controller,el){if(e.target.contains(el)){controller.destroy();controllers.delete(el);}});
  });
  document.addEventListener('shopify:block:select',function(e){
    var id=e.detail&&e.detail.blockId;
    controllers.forEach(function(controller){if(controller.root.contains(e.target))controller.select(id);});
  });
  document.addEventListener('shopify:block:deselect',function(e){
    controllers.forEach(function(controller){if(controller instanceof Notices && controller.root.contains(e.target))controller.paused=false;});
  });
  document.addEventListener('visibilitychange',function(){refresh();controllers.forEach(function(c){if(c.setPlayback)c.setPlayback();});});
  window.addEventListener('pageshow',function(){scan();refresh();});
  var resizeTimer;
  window.addEventListener('resize',function(){clearTimeout(resizeTimer);resizeTimer=setTimeout(refresh,100);});
  setInterval(refresh,1000);
  if(window.ResizeObserver){
    var stack=document.querySelector('[data-km-header-stack]');
    if(stack)new ResizeObserver(measureHeader).observe(stack);
  }
})();
